import _ from 'lodash'

import { dashedOutOrWithPrecision, PolicyGioValueRow } from './policy-value-row'
import MESSAGES from 'core/data-model/constants/bi-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import { getSubtotalNonGuaranteeDividend } from 'core/service/pdf-generation/products/term-life/sections/policy-value-table-example-section'
import { formatNumber } from 'core/service/lib/number-format'
import Mustache from 'mustache'

const getRateWording = (rate) => {
  switch (rate) {
    case -1:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_LOW
    case 3:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_MIDDLE
    case 5:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH
    default:
      return MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH
  }
}

const getExample = (rate) => {
  switch (rate) {
    case -1:
      return MESSAGES.EXAMPLE_1
    case 3:
      return MESSAGES.EXAMPLE_2
    case 5:
      return MESSAGES.EXAMPLE_3
    default:
      return MESSAGES.EXAMPLE_1
  }
}

const PolicyValueGioTable = (props) => {
  return (
    <div className="policy group" id="policy-value">
      {[-1, 3, 5].map((rate, index) => {
        return (
          <div id={`policy-value-${index + 1}`} className="example" style={{ marginBottom: '30px' }}>
            <h3 className="name">
              <span className="example-name">{getExample(rate)}</span> {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
              {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {getRateWording(rate)}
            </h3>
            {renderNotePolicyValueTableForGio(props, rate, index)}
          </div>
        )
      })}
    </div>
  )
}

const PolicyTable = ({ className, children }) => (
  <table
    className={`policy-table${className ? ` ${className}` : ''}`}
    id="policy-value-table"
    style={{ width: '1400px' }}
  >
    {children}
  </table>
)

const getBreakWord = (word, breakWord) => {
  return (
    <>
      {word.slice(0, word.indexOf(breakWord))}
      <br />
      {word.slice(word.indexOf(breakWord))}
    </>
  )
}

export const PolicyGio = ({
  yearEndPolicyValues,
  lastYearEndPolicy,
  subtotalAnnualBasicPremium,
  subtotalCashDrop,
  subtotalLowSavingCashDrop,
  rate,
  subtotalNonGuaranteeDividend,
}) => (
  <PolicyTable className="with-cash-drop">
    <thead>
      <tr>
        <td rowSpan={2} width="5%">
          {CONSTANTS.AGE}
        </td>
        <td rowSpan={2} className="nowrap" width="7%">
          {MESSAGES.GIO_END_OF_POLICY}
        </td>
        <td colSpan={2}>
          <div>{MESSAGES.BASIC_PREMIUM}</div>
        </td>
        <td colSpan={2} width="14%">
          {getBreakWord(
            MESSAGES.GLOBAL_INDEX_16_6_GUARANTEE_CASHDROP.replace(
              new RegExp(`\\(${MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}\\)`, 'g'),
              ''
            ),
            'และ'
          )}
          <br />
          {MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}
        </td>
        <td colSpan={2} width="13%">
          {getBreakWord(MESSAGES.IN_CASE_DEATH_COVERAGE_END_OF_POLICY, '(')}
        </td>
        <td colSpan={2} width="15%">
          {MESSAGES.IN_CASE_SURRENDER_VALUE_END_OF_POLICY.replace(
            new RegExp(`\\(${MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}\\)`, 'g'),
            ''
          ).trim()}
          <br />
          {MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}
        </td>
      </tr>
      <tr>
        <td width="10%">ต่อปี</td>
        <td width="10%">สะสม</td>
        <td width="10%">{getBreakWord(MESSAGES.INCASE_OF_CASH_BACK, 'จ่าย')}</td>
        <td width="10%">
          {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_1, 'บริษัท')}
          {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_2, '0.5')}
        </td>
        <td width="10%">
          {getBreakWord(MESSAGES.GLOBAL_INDEX_16_6_DEATH_BENEFIT_GUARANTEE, 'กรณี')}
          <br />
          {MESSAGES.GLOBAL_INDEX_16_6_GUARANTEE}
        </td>
        <td width="10%">
          {MESSAGES.GLOBAL_INDEX_16_6_DEATH_BENEFIT_NON_GUARANTEE.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < 2 && <br />}
            </React.Fragment>
          ))}
          <sup>(4),(4.2)</sup>
          <br />
          (ถ้ามี)
        </td>
        <td width="12%">
          {getBreakWord(MESSAGES.POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER, 'กรม')}
          <sup>(2),(3)</sup>
          <br />
          {MESSAGES.GLOBAL_INDEX_16_6_GUARANTEE}
        </td>
        <td width="12%">
          {getBreakWord(MESSAGES.POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER, 'กรม')}
          <br />
          {MESSAGES.INCLUDE_DIVIDEND}
          <sup>(4),(4.3)</sup>
          <br />
          (ถ้ามี)
        </td>
      </tr>
    </thead>
    <tbody>
      {yearEndPolicyValues.map((policyValue) => {
        const dividendValue = policyValue.dividend.dividendValue.find((value) => value.title === rate.toString())
        return (
          <PolicyGioValueRow
            key={`policy-value-row-${policyValue.age.value}`}
            age={policyValue.age}
            yearEndPolicy={policyValue.yearEndPolicy}
            annualBasicPremium={policyValue.annualBasicPremium}
            cumulativeBasicPremium={policyValue.cumulativeBasicPremium}
            cashDrop={policyValue.cashDrop}
            lowSavingCashDrop={policyValue.lowSavingCashDrop}
            deathBenefit={policyValue.deathBenefit}
            deathBenefitPlusNonGuaranteeDividend={dividendValue.deathBenefitPlusNonGuaranteeDividend}
            surrenderCash={policyValue.surrenderCash}
            surrenderCashPlusNonGuaranteeDividendSurrender={
              dividendValue.surrenderCashPlusNonGuaranteeDividendSurrender
            }
          />
        )
      })}
      <tr className="total" id={`policy-value-row-${lastYearEndPolicy}`} key={`policy-value-row-${lastYearEndPolicy}`}>
        <td colSpan={2} className={'td-total'}>
          {MESSAGES.FUND_RISK_TOTAL}
        </td>
        <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 0)}</td>
        <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 0)}</td>
        <td>{dashedOutOrWithPrecision(subtotalCashDrop, 0)}</td>
        <td>{dashedOutOrWithPrecision(subtotalLowSavingCashDrop, 0)}</td>
        <td colSpan={4} style={{ background: '#f5f5f5' }} />
      </tr>
      <tr className="total">
        <td colSpan={4} className={'td-total'}>
          {MESSAGES.DIVIDEND}
          <sup>(4),(4.1)</sup> {MESSAGES.MATURITY_DATE}
          <br />
          {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
          {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {getBreakWord(getRateWording(rate), 'ต่อ')}
        </td>
        <td colSpan={2} className={'td-total sum-total'} style={{ fontWeight: 'normal' }}>
          {formatNumber(getSubtotalNonGuaranteeDividend(rate, { subtotalNonGuaranteeDividend }), 0, true)}
        </td>
        <td colSpan={4} style={{ background: '#f5f5f5', border: 'none' }} />
      </tr>
    </tbody>
  </PolicyTable>
)

export const PolicyValueContent = ({ basicPlan, ...props }) => {
  return <PolicyGio {...props} />
}

const fraction = (top, bottom) => (
  <span
    style={{
      display: 'inline-block',
      textAlign: 'center',
      margin: '0 0.1em',
      verticalAlign: 'middle',
    }}
  >
    <span
      style={{
        display: 'block',
        borderBottom: '1px solid black',
        padding: '0 0.2em',
        marginBottom: '-0.2em',
      }}
      class="numerator"
    >
      {top}
    </span>
    <span style={{ display: 'block', marginTop: '0.1em' }}>{bottom}</span>
  </span>
)

const dataForDividendTable = [
  ['1-6', '0'],
  ['7', '10'],
  ['8', '20'],
  ['9', '30'],
  ['10', '40'],
  ['11', '50'],
  ['12', '60'],
  ['13', '70'],
  ['14', '80'],
  ['15', '90'],
  ['16', '100'],
]

const renderNotePolicyValueTableForGio = ({ policyValue, basicPlan }, rate, index) => {
  const lastYearEndPolicy = _.get(_.last(policyValue.yearEndPolicyValues), 'yearEndPolicy', 0) + 1
  const dividendValue = policyValue.yearEndPolicyValues[
    policyValue.yearEndPolicyValues.length - 1
  ].dividend.dividendValue.find((value) => value.title === rate.toString())
  return (
    <div>
      <div className="table-wrap">
        <PolicyValueContent lastYearEndPolicy={lastYearEndPolicy} basicPlan={basicPlan} {...policyValue} rate={rate} />
      </div>
      <div className="disclaimer">
        <table className="formula">
          <tr>
            <td className="title">ตัวอย่างการคำนวณ</td>
            <td></td>
          </tr>
          <tr>
            <td className="title">เงินปันผล ณ วันครบกำหนดสัญญา</td>
            <td>
              = จำนวนเบี้ยฯ ที่ชำระมาทั้งหมด X Max ( 0,{' '}
              {fraction('ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันสุดท้าย', 'ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันแรก')} -
              100%) X อัตราการมีส่วนร่วมในเงินปันผล⁽¹⁾ X ({' '}
              {fraction('อัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าวันสุดท้าย', 'อัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าวันแรก')} )
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              = {dashedOutOrWithPrecision(policyValue.subtotalAnnualBasicPremium, 0)} X Max ( 0,{' '}
              {fraction(dividendValue.currentIndex, 100)} - 100%) X 80% X {fraction(35, 35)}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>= {formatNumber(getSubtotalNonGuaranteeDividend(rate, policyValue), 0, true)} บาท</td>
          </tr>
        </table>
        <br />
        <p>
          {MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[0]} {MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[1]}
        </p>
        <br />
        <p style={{ color: '#000000' }}>{MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[2]}</p>
        <p>{MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[3]}</p>
        <p>
          {Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[4], {
            rate: rate,
            dividendIndex: dividendValue.currentIndex,
          })}
        </p>
        <p>{MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[5]}</p>
        <p>{MESSAGES.GLOBAL_INDEX_16_6_FORMULA_REMARK[6]}</p>
        <br />
        <p style={{ color: '#000000' }}>{MESSAGES.NOTE}</p>
        <div id="meh-exception-note32">
          <ol className="list-cell" style={{ marginLeft: '-40px' }}>
            <li style={{ display: 'block' }}>
              <span>(1)</span>
              <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_1[0]}</span>
            </li>
            <li style={{ display: 'block' }}>
              <span>(2)</span>
              <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_1[1]}</span>
            </li>
            <li style={{ display: 'block' }}>
              <span>(3)</span>
              <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_1[2]}</span>
            </li>
            <li style={{ display: 'block' }}>
              <span>(4)</span>
              <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_1[3]}</span>
              <ol className="list-cell">
                <li style={{ display: 'block' }}>
                  <span>(4.1)</span>
                  <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_2[0]}</span>
                </li>
                <li style={{ display: 'block' }}>
                  <span>(4.2)</span>
                  <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_2[1]}</span>
                </li>
                <li style={{ display: 'block' }}>
                  <span>(4.3)</span>
                  <span>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_2[2]}</span>
                </li>
              </ol>
            </li>
          </ol>
        </div>
        <div className="dividend-table">
          <table width="100%">
            <thead>
              <tr>
                <td width="50%">{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.table_header[0]}</td>
                <td width="50%">
                  {MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.table_header[1].split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </td>
              </tr>
            </thead>
            <tbody style={{ textAlign: 'center' }}>
              {dataForDividendTable.map((data) => (
                <tr>
                  <td>{data[0]}</td>
                  <td>{data[1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        <ul className="dash">
          <li>
            {Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_3[0].replace(/\n/g, ''), {
              rate: rate,
              index: index + 1,
            })}
          </li>
          <li>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_3[1]}</li>
          <li>{MESSAGES.GLOBAL_INDEX_16_6_DISCLAIMER.note_3[2]}</li>
        </ul>
      </div>
    </div>
  )
}

export default PolicyValueGioTable
